<script lang="ts">
  import type { RadarAvatarPerson } from "../model";

  let { person, tooltipId, muted = false }: { person: RadarAvatarPerson; tooltipId: string; muted?: boolean } = $props();
  let imageFailed = $state(false);
  let label = $derived(person.name?.trim() || "Unknown person");
  let initials = $derived(label === "Unknown person"
    ? "?"
    : label.split(/\s+/).slice(0, 2).map((part) => part[0]).join("").toLocaleUpperCase());

  $effect(() => {
    person.avatarUrl;
    imageFailed = false;
  });
</script>

<span class:muted class="person-avatar-wrap">
  <!-- Focus is intentional so keyboard users can reveal the name tooltip. -->
  <!-- svelte-ignore a11y_no_noninteractive_tabindex -->
  <span
    class="person-avatar"
    role="img"
    tabindex="0"
    aria-label={label}
    aria-describedby={tooltipId}
  >
    <span aria-hidden="true">{initials}</span>
    {#if person.avatarUrl && !imageFailed}
      <img src={person.avatarUrl} alt="" onerror={() => imageFailed = true} />
    {/if}
  </span>
  <span class="avatar-tooltip" id={tooltipId} role="tooltip">{label}</span>
</span>
